









































































































































































import axios from 'axios';
import Vue from 'vue';
import EventBus from '@/eventBus';
import { P } from 'vue-long-click';
// import { now } from 'moment-timezone';

export default {
    name: 'AdminEditTimepass',

    data() {
        return {
            form: {
                Currency: 'EUR',
            },
            timepass: {
                type: Object,
                default: null,
            },
            taxRates: [],
            loadingTaxRate: false,
            FinalPrice: 0.0,
            price: 0.0,
            loading: false,
        };
    },
    created() {
        this.getTaxRates();
    },
    mounted() {
        this.getTimePassByID(this.$route.params.ID);
    },

    methods: {
        getTimePassByID(ID) {
            this.loading = true;
            axios({
                method: 'GET',
                url: `/admin/time-pass/list`,
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {
                    if (response && response.data) {
                        const catchTimePass = response.data.Passes.find((item) => item.ID === ID);
                        this.timepass = catchTimePass;
                        this.form = {
                            ID: this.timepass.ID,
                            Name: this.timepass.Name,
                            Number: this.timepass.Number,
                            Duration: this.timepass.Duration,
                            Currency: this.timepass.Currency,
                            TaxRateID: this.timepass.TaxRateID,
                        };
                        if (this.timepass.PriceInCents) {
                            this.price = this.timepass.PriceInCents / 100.0;
                        }
                        if (this.timepass.TaxRateID) {
                            this.form.TaxRateID = this.timepass.TaxRateID;
                            this.getTaxRates();
                        }
                        if (this.$store.state.space.Currency) {
                            this.form.Currency = this.$store.state.space.Currency;
                        }
                        this.loading = false;
                    }
                })
                .catch((error) => {
                    this.loading = false;
                    console.log(error);
                });
        },
        getTaxRates() {
            this.loadingTaxRate = true;
            axios({
                method: 'GET',
                url: `/admin/tax-rate/list`,
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {
                    if (response && response.data) {
                        this.taxRates = response.data;
                        this.calculateFinalPrice(this.form.TaxRateID);
                    }
                    this.loadingTaxRate = false;
                })
                .catch((error) => {
                    this.loadingTaxRate = false;
                    console.log(error);
                });
        },
        priceChange() {
            if (this.form.TaxRateID) {
                this.calculateFinalPrice(this.form.TaxRateID);
            }
        },
        calculateFinalPrice(taxID) {
            const tax = this.taxRates.find((item) => item.ID === taxID);

            if (tax && tax.Inclusive) {
                this.FinalPrice = this.price;
            } else {
                this.FinalPrice = (this.price * (tax.Percentage / 100 + 1)).toFixed(2);
            }
        },
        handleUpdateSubmit() {
            // validate form
            const { createResource } = this.$refs;
            if (createResource) {
                if (!createResource.checkValidity()) {
                    createResource.reportValidity();
                    return;
                }
            } else {
                return;
            }
            this.loading = true;
            this.timepass.PriceInCents = this.price * 100;
            this.timepass.TaxRateID = this.form.TaxRateID;
            this.timepass.Currency = this.form.Currency;
            this.timepass.Name = this.form.Name;
            this.timepass.Number = this.form.Number;
            this.timepass.Duration = this.form.Duration;

            if (this.timepass?.Duration < 1) {
                const message = {
                    Message: this.$t('messages.durationMustBeSet'),
                    Details: '',
                };
                EventBus.$emit('ERROR', message);
                this.loading = false;
                return;
            }

            this.$store
                .dispatch('editTimepass', this.timepass)
                .then((response) => {
                    const message = {
                        Message: this.$t('messages.changessaved'),
                        Details: '',
                    };
                    EventBus.$emit('INFO', message);
                    this.loading = false;
                })
                .catch((error) => {
                    const message = {
                        Message: this.$t('messages.timepassUpdateFailed'),
                        Details: error,
                    };
                    this.loading = false;
                    EventBus.$emit('ERROR', message);
                });
            this.loading = false;
        },
        handleCancel() {
            this.$router.push(`/admin/monetization/time-passes`);
        },
    },
};
